// extracted by mini-css-extract-plugin
module.exports = {"help_me":"help_me_help_me__APaZs","question_symbol":"help_me_question_symbol__4Qvpn","help_me_text":"help_me_help_me_text__tyufI"};